import { useState } from "react";
import { Button, CopyButton, Group } from "@mantine/core";
import { useSelector } from "react-redux";
import { fetcher } from "../../../../services/fetcher";
import {
  errorNotifications,
  successNotifications,
} from "../../../../utils/handleNotifications";
import { USER_TYPES } from "../../../../utils/userTypes";
import {
  getPaymentLinkUrl,
  SEND_PAYMENT_REMINDER_ENDPOINT,
} from "../../utils/allPolicyConstants";
import { canShowTripPaymentActions } from "../../utils/allPolicyHelpers";
import classes from "./TripPolicyDrawer.module.css";

const TripDrawerPaymentActions = ({ trip }) => {
  const [isSending, setIsSending] = useState(false);
  const roles = useSelector((state) => state.auth.role) || [];
  const userType = useSelector((state) => state.auth.user_type) || [];
  const isOperator =
    (Array.isArray(roles) ? roles : [roles]).includes("Operator") ||
    (Array.isArray(userType) ? userType : [userType]).includes(USER_TYPES.OPERATOR);

  if (isOperator || !canShowTripPaymentActions(trip)) return null;

  const paymentLink = getPaymentLinkUrl(trip.uuid);

  const handleSend = async () => {
    if (isSending) return;

    setIsSending(true);
    try {
      await fetcher(SEND_PAYMENT_REMINDER_ENDPOINT, "POST", {
        trip_uuid: trip.uuid,
      });
      successNotifications("Payment link sent successfully");
    } catch (error) {
      errorNotifications(error?.response?.data || "An error occurred", error);
    } finally {
      setIsSending(false);
    }
  };

  return (
    <Group className={classes.paymentActions} grow>
      <Button color="brand" loading={isSending} onClick={handleSend}>
        Send Payment Link
      </Button>
      <CopyButton value={paymentLink} timeout={2000}>
        {({ copied, copy }) => (
          <Button
            variant="outline"
            color={copied ? "teal" : "brand"}
            onClick={copy}
            fullWidth
          >
            {copied ? "Copied" : "Copy Payment Link"}
          </Button>
        )}
      </CopyButton>
    </Group>
  );
};

export default TripDrawerPaymentActions;
